function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvrLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-flow-tree",
    d: "M36.815 29.705v-4.45a6.7 6.7 0 0 0-6.7-6.7h-3.83a2.873 2.873 0 0 1-2.872-2.872V11.23a4.6 4.6 0 1 0-3.83 0v4.45a2.873 2.873 0 0 1-2.872 2.872h-3.83a6.7 6.7 0 0 0-6.7 6.7v4.45a4.6 4.6 0 1 0 3.83 0v-4.45a2.873 2.873 0 0 1 2.872-2.872h3.83a6.632 6.632 0 0 0 2.872-.67v7.993a4.6 4.6 0 1 0 3.83 0v-7.99a6.632 6.632 0 0 0 2.872.67h3.83a2.873 2.873 0 0 1 2.872 2.872v4.45a4.6 4.6 0 1 0 3.83 0zM21.5 4.412a2.652 2.652 0 1 1-2.65 2.652 2.65 2.65 0 0 1 2.65-2.652zM8.092 36.524a2.652 2.652 0 1 1 2.65-2.652 2.652 2.652 0 0 1-2.65 2.652zm13.4 0a2.652 2.652 0 1 1 2.65-2.652 2.652 2.652 0 0 1-2.65 2.652zm13.4 0a2.652 2.652 0 1 1 2.65-2.652 2.652 2.652 0 0 1-2.65 2.652z",
    transform: "translate(-3.496 -2.468)",
    style: {
      fill: "#ed3833"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvrLevel);
export default __webpack_public_path__ + "static/media/ivr_level.d92479d5f6c165ab61ab8c6ea4eb2ed4.svg";
export { ForwardRef as ReactComponent };